module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'invite-success' : 'invite-success-mobile',
    attrs: {
      "id": "invite-success"
    }
  }, [(_vm.isPC) ? _c('Icon') : _vm._e(), _vm._v(" "), (!_vm.isPC) ? _c('Top') : _vm._e(), _vm._v(" "), _c('Iconsuccess', {
    style: ({
      marginTop: (_vm.isPC ? '30px' : '80px')
    })
  }), _vm._v(" "), (!_vm.$route.query.invitename && !_vm.$route.query.invitegroup) ? _c('p', [_vm._v(_vm._s(_vm.title3))]) : (+_vm.$route.query.invitetype === 1) ? _c('p', [_vm._v(_vm._s(_vm.title1))]) : (+_vm.$route.query.invitetype === 3) ? _c('p', [_vm._v(_vm._s(_vm.title4))]) : _c('p', [_vm._v(_vm._s(_vm.title2))]), _vm._v(" "), _c('Buttons', {
    attrs: {
      "type": 'open'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f5c297d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/new-invite/Invitesuccess.vue
// module id = 713
// module chunks = 1